import React, { useEffect, useState } from "react";
import { Modal, Box, IconButton, Stack, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import { ManualInputBulkAssign } from "./manual-input-bulk-assign";
import FormattedIdList from "./formatted-id-list";
import { toast } from "react-hot-toast";

import { CONFIG } from "../../../../../../config";
import axios from "axios";
import { NeedUnassignedList } from "../../../master-database/features/need-unassigned-list";
import { set } from "lodash";
import { useSelector } from "react-redux";
import SelectAgent from "./select-agent";

const API_HOST_CRM = CONFIG.modules["crm"].host;

const centeredModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    md: "70%",
  },
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

const BulkModalAssign = ({
  // props from parents
  bulkAssignOpen,
  handleBulkAssignModelClose,
}) => {
  // redux
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    map,
  } = useSelector((state) => state.user || {});

  const theme = useTheme(); // Access the theme

  // mode of bulk assign
  const [bulkAssignMode, setBulkAssignMode] = useState(null);

  // data for bulk assign
  const [bulkAssignData, setBulkAssignData] = useState(new Map());

  // data for the bulk assign but these are from the back end
  const [bulkAssignFetchedData, setBulkAssignFetchedData] = useState([]);

  // state to dictate whether to show the list or not
  const [showList, setShowList] = useState(false);

  // state to store the cases that need to be unassigned
  const [needToBeUnassignedCases, setNeedToBeUnassignedCases] = useState(
    new Map(),
  );

  // state to show if its unassigning
  const [isUnassigning, setIsUnassigning] = useState(false);

  // state to store whether the cases are being fetched
  const [isFetchingSelectedCasesDetails, setIsFetchingSelectedCasesDetails] =
    useState(false);

  const handleBulkAssignMode = (mode) => {
    // currently only manual input mode is supported
    setBulkAssignMode(mode);
  };

  const handleTextFileModeClick = () => {
    // textFileInputRef.current.click();
  };

  const handleExcelFileModeClick = () => {
    // excelFileInputRef.current.click();
  };

  const handleDeleteChip = (id) => {
    let newBulkAssignData = new Map(bulkAssignData);
    newBulkAssignData.delete(id);
    setBulkAssignData(newBulkAssignData);
  };

  const manualInputBulkAssignSaveHandler = (data) => {
    // data will be a string
    console.log("what did hte user paste", data);
    // this seperates the data by spaces and new lines
    let dataArray = data.split(/[ \n]/);

    // now need to only get the data that is in the format of MOTHER-numbers
    // the regular expression to match the pattern MOTHER- followed by digits (case-insensitive)
    const pattern = /^MOTHER-\d+$/i;

    // Filter the array to only include elements that match the pattern
    let filteredArray = dataArray.filter((item) => pattern.test(item));

    // Now need to remove any duplicates
    filteredArray = [...new Set(filteredArray)];

    console.log("dataArray", filteredArray);

    // check the length of the filteredArray
    if (filteredArray.length === 0) {
      toast.error("No valid mother ids found");
      return;
    }

    // now need to map the filteredArray to a Map
    let newBulkAssignDataMap = new Map();

    filteredArray.forEach((id) => {
      newBulkAssignDataMap.set(id, id);
    });

    setBulkAssignData(newBulkAssignDataMap);
    console.log("the map is here", newBulkAssignDataMap);

    // now its time to show the list
    setBulkAssignMode("show-list");
  };

  // UNASSIGN CASES RELATED
  // GET CASE DETAILS
  const fetchCasesThatNeedToBeUnassigned = async () => {
    let newNeedUnassignedMap = new Map();

    // get the keys of bulkAssignData
    // These are actually motherID
    const caseIds = Array.from(bulkAssignData.keys());

    // make a network request to get the details of the cases
    try {
      setIsFetchingSelectedCasesDetails(true);
      const result = await axios.post(
        API_HOST_CRM + "/ecd/selected-cases-details/mother-ids",
        {
          cases: caseIds, // this is motherid
        },
      );

      if (result.data.success) {
        const cases = result.data.cases;
        setBulkAssignFetchedData(cases);
        console.log("result data", result.data);
        cases.forEach((e) => {
          if (e.status !== "Queue") {
            newNeedUnassignedMap.set(e._id, e);
          }
        });
      }
    } catch (error) {
      toast.error("Error in fetching selected cases details");
      console.log(error);
    } finally {
      setIsFetchingSelectedCasesDetails(false);
    }

    if (newNeedUnassignedMap.size > 0) {
      console.log("newNeedUnassignedMap", newNeedUnassignedMap);
      setNeedToBeUnassignedCases(newNeedUnassignedMap);
      setBulkAssignMode("unassign-selected");
      toast(`${newNeedUnassignedMap.size} rows need to be unallocated `);
    } else {
      toast("No cases need to be unallocated", {
        position: "top-center",
      });
      setBulkAssignMode("select-agent");
    }

    return newNeedUnassignedMap;
  };

  // THESE ONE WILL UNASSIGN NETWORK REQUEST
  const unassignSelectedRows = () => {
    setIsUnassigning(true);

    // replace it with a new api or use the same
    axios
      .put(API_HOST_CRM + "/ecd/unassign-pendings", {
        caseIds: Array.from(needToBeUnassignedCases.keys()),
        reason: "66b1a4f1999b4aa3b0a6e170",
      })
      .then((resp) => {
        if (resp.data && resp.data.success) {
          // getList(true);

          toast.success(`${needToBeUnassignedCases.size} cases unallocated`, {
            position: "top-center",
            duration: 3800,
          });
          toast.success("Unassigned Successfully", {
            position: "top-center",
            duration: 3800,
          });
          setNeedToBeUnassignedCases(new Map());
          setBulkAssignMode("show-list");
          // let newStaticSelectedRows = new Map(staticSelectedRows);
          // now we need to loop over selectedRows and update the state and status to "Unalloted" and "Queue"
          // Array.from(needToBeUnassignedCases.keys()).forEach((e) => {
          //     if (bulkAssignData.has(e)) {
          //         let newUpdatedRow = {
          //             ...bulkAssignData.get(e),
          //             allocatedToUser: null,
          //             callDate: null,
          //             allocatedTo: null,
          //             state: "Unalloted",
          //             // dataType: "olddata",
          //             status: "Queue",
          //             unassigned: true,
          //             unAssignedOn: new Date(),
          //             unAssignedBy: user._id,
          //             unassignReason: "66b1a4f1999b4aa3b0a6e170",
          //         };
          //         newStaticSelectedRows.set(e, newUpdatedRow);
          //     }
          // });
          // setStaticSelectedRows(newStaticSelectedRows);
        }
        setIsUnassigning(false);
      })
      .catch((e) => {
        console.log(e);
        toast.error("Error in unassigning cases");
        setIsUnassigning(false);
      });
  };

  const handleRemoveStaticSelection = (id, motherID) => {
    console.log("what is the id to be removed", id, motherID);

    setBulkAssignData((prevBulkAssignData) => {
      const newBulkAssignData = new Map(prevBulkAssignData);

      // here we were using caseid but there will be multiple cases
      // so it would be better to use motherID
      // SO here we will find the motherid out of the staticSelectedRows
      const matchingCase = Array.from(newBulkAssignData.values()).filter(
        (data) => {
          return data === motherID;
        },
      );

      if (matchingCase.length === 0) {
        return newBulkAssignData;
      }

      // Delete the specified ID from the new Map
      // newStaticSelectedRows.delete(id);
      newBulkAssignData.delete(matchingCase[0]);
      // console.log("what the static rows before", prevStaticSelectedRows);
      // console.log("how many times being called from active.js", id);
      // Return the updated Map to set the new state
      return newBulkAssignData;
    });
  };

  const handleSelectAgentBackButton = () => {
    setBulkAssignMode("show-list");
  };

  // useEffect to set the mode to null
  useEffect(() => {
    return () => {
      setBulkAssignMode(null);
    };
  }, []);

  useEffect(() => {
    // need to make sure the modeis null when the data is empty
    if (bulkAssignData.size === 0) {
      setBulkAssignMode(null);
    }
  }, [bulkAssignData]);

  return (
    <Modal
      open={bulkAssignOpen}
      onClose={() => {
        setBulkAssignMode(null);
        handleBulkAssignModelClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={centeredModalStyle}>
        <IconButton
          onClick={() => {
            setBulkAssignMode(null);
            handleBulkAssignModelClose();
          }}
          sx={{ position: "absolute", top: 8, right: 8 }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <Stack direction="column" spacing={2} position="relative">
          <Stack direction="row" spacing={2} justifyContent="center">
            {/* <Button
                        variant="contained"
                        onClick={() => {
                            handleBulkAssignMode("text");
                            handleTextFileModeClick();
                        }}
                        sx={{
                            backgroundColor:
                                bulkAssignMode === "text" ? "#0000CC" : "primary",
                        }}
                    >
                        Upload Text File
                    </Button> */}
            {/* <Button
                        variant="contained"
                        onClick={() => {
                            handleBulkAssignMode("excel");
                            handleExcelFileModeClick();
                        }}
                        sx={{
                            backgroundColor:
                                bulkAssignMode === "excel" ? "#0000CC" : "primary",
                        }}
                    >
                        Upload Excel Sheet
                    </Button> */}
            <Button
              variant="contained"
              onClick={() => handleBulkAssignMode("manual")}
              sx={{
                backgroundColor:
                  bulkAssignMode === "manual" ? "#0000CC" : "primary",
              }}
            >
              Enter Manually
            </Button>
          </Stack>

          {bulkAssignMode === "manual" && (
            <Stack direction={"column"}>
              <ManualInputBulkAssign
                label={"Enter Mother Ids by separating them with spaces"}
                placeholder={"Example: MOTHER-123456789 MOTHER-123456789"}
                manualInputBulkAssignSaveHandler={
                  manualInputBulkAssignSaveHandler
                }
              />
            </Stack>
          )}

          {bulkAssignMode === "excel" && <div>Current Mode: Excel</div>}

          {bulkAssignMode === "text" && (
            <Stack direction={"column"}>
              <div>Current Mode: Text</div>
            </Stack>
          )}

          {bulkAssignMode === "show-list" && (
            <Stack direction={"column"}>
              <FormattedIdList
                idListMap={bulkAssignData}
                onDelete={handleDeleteChip}
              />
              <Stack
                direction={"row"}
                spacing={2}
                justifyContent={"center"}
                pt={1}
              >
                <Button
                  variant="contained"
                  onClick={() => {
                    fetchCasesThatNeedToBeUnassigned();
                  }}
                >
                  Fetch Cases
                </Button>
              </Stack>
            </Stack>
          )}
          {bulkAssignMode === "unassign-selected" && (
            <NeedUnassignedList
              data={needToBeUnassignedCases}
              setData={setNeedToBeUnassignedCases}
              handleBack={() => setBulkAssignMode("show-list")}
              unassign={unassignSelectedRows}
              onRemoveCaseSelection={handleRemoveStaticSelection}
              onAssignCases={(caseIds) => {
                // setCasesToBeUnassigned([])
                // setBulkAssignMode("show-list")
                // assignCases(caseIds)
              }}
            />
          )}
          {bulkAssignMode === "select-agent" && (
            <SelectAgent
              cases={bulkAssignFetchedData}
              handleBack={handleSelectAgentBackButton}
              assignComplete={() => {
                setBulkAssignMode(null);
                handleBulkAssignModelClose();
              }}
            />
          )}
        </Stack>
      </Box>
    </Modal>
  );
};

export default BulkModalAssign;
